import { Heading } from '@art-of-hospitality-solutions-llc/ui-kit/components/heading';
import { toastError } from '@art-of-hospitality-solutions-llc/ui-kit/components/toast';
import Breadcrumbs from '@Components/Breadcrumbs';
import { useWorkspaces } from '@Hooks/useWorkspaces';
import { useEffect } from 'react';
import WorkspaceCard from '@Components/WorkspaceCard';

export default function WorkspaceCards() {
  const {
    data: workspaces,
    isError,
    error,
  } = useWorkspaces({
    searchParams: {
      include: 'dashboards.dashboard',
    },
  });

  useEffect(() => {
    if (isError && error) {
      toastError(
        error instanceof Error ? error.message : 'Failed to load Workspaces',
      );
    }
  }, [isError, error]);

  return (
    <div className="h-full w-full overflow-y-auto">
      <Breadcrumbs
        navList={[
          { name: 'Workspaces', href: '/workspaces' },
          { name: 'Cards', href: '/workspaces/cards' },
        ]}
      />
      <div className="mt-8 mb-4 flex items-center justify-between">
        <div>
          <Heading>Workspaces</Heading>
          <p>View workspaces within your organization.</p>
        </div>
      </div>
      <div className="grid min-w-300 grid-cols-4 gap-6 overflow-auto">
        {workspaces?.data?.length &&
          workspaces.data.map((ws) => {
            return <WorkspaceCard key={ws.id} workspace={ws} />;
          })}
      </div>
    </div>
  );
}
